module.exports = __webpack_public_path__ + "img/icon.ef20b47c.png";